import { ClassAttributes, createElement } from 'react';
import { RouteComponentProps } from 'react-router';

import RouteLifecycleWrapper from '../component/primitive/RouteLifecycleWrapper';
import { Consumer as DependencyConsumer } from '../context/dependency';
import { Consumer as StateConsumer } from '../context/state';
import _ProjectDiffPage from '../page/ProjectDiffPage';

type UrlParams = {
  projectId: string;
};

type Props = ClassAttributes<HTMLElement> & RouteComponentProps<UrlParams>;
const ProjectDiffPage = ({ match }: Props) => (
  <DependencyConsumer>
    {(dependency) => (
      <StateConsumer>
        {(state) => (
          <RouteLifecycleWrapper
            match={match}
            isRouteChanged={(current, previous) => current.params.projectId !== previous.params.projectId}
            onMount={async () => {
              dependency.authenticationUsecase.needSignedIn();
              await dependency.showProjectUsecase.prepare(match.params.projectId);
            }}
            onUnmount={() => dependency.showProjectUsecase.dispose()}
          >
            <_ProjectDiffPage
              project={state.project.project}
              projectChange={state.project.projectChange}
              assetFiles={state.project.assetFiles}
              briefFiles={state.project.briefFiles}
              latestBriefFiles={state.project.latestBriefFiles}
              beforeBriefFiles={state.project.beforeBriefFiles}
              projectLoading={state.project.fetching >= 1}
            />
          </RouteLifecycleWrapper>
        )}
      </StateConsumer>
    )}
  </DependencyConsumer>
);

export default ProjectDiffPage;
